// extracted by mini-css-extract-plugin
export default {"link":"PrimaryLink_link__7U7S1","underline":"PrimaryLink_underline__rJ2wb"};